enum StatisticEvent {
    //統計情報取得
    GetStatisticsStarted = "[StatisticsEvent] GetStatisticsStarted",
    GetStatisticsCompleted = "[StatisticsEvent] GetStatisticsCompleted",
    //ランキング情報取得
    GetPopularRankingStarted = "[StatisticsEvent] GetPopularRankingStarted",
    GetPopularRankingCompleted = "[StatisticsEvent] GetPopularRankingCompleted",
    //Slidestock統計情報取得
    GetDocumentStatisticsStarted = "[StatisticsEvent] GetDocumentStatisticsStarted",
    GetDocumentStatisticsCompleted = "[StatisticsEvent] GetDocumentStatisticsCompleted",
    //ランキング情報取得
    GetDocumentPopularRankingStarted = "[StatisticsEvent] GetDocumentPopularRankingStarted",
    GetDocumentPopularRankingCompleted = "[StatisticsEvent] GetDocumentPopularRankingCompleted",
    // 統計情報の登録(ドキュメント）
    SaveDocumentStatisticsStarted = "[StatisticsEvent] SaveDocumentStatisticsStarted",
    SaveDocumentStatisticsCompleted = "[StatisticsEvent] SaveDocumentStatisticsCompleted",
}

export default StatisticEvent;
